let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hlo4z")).then(() => parcelRequire('h7nPi'));